import {
  Table,
  TableContainer,
  Tbody,
  Th,
  Thead,
  Tr,
  Flex,
  Input,
  Button,
  Text
} from '@chakra-ui/react';
import { HeadingPages } from '../../../components/HeadingPages';
import { Layout } from '../../../components/Layout';
import { api } from '../../../services/api/index';
import { useMutation } from 'react-query';
import { useForm } from 'react-hook-form';
import { formatPrice } from '../../../utils/formatPrice';
import { useEffect, useState } from 'react';
import { RowsContainer } from './RowsContainer';

async function getRelatorioChamados(data) {
  console.log(data);
  const response = await api.post(`/site/v2/crm-controle/resumo-chamados`, {
    data_inicial: data.data_inicial,
    data_final: data.data_final
  });

  const totalPedidos = response.data.data.reduce((acc, item) => {
    return acc + Number(item.total_pedidos);
  }, 0);

  const totalValorPedidos = response.data.data.reduce((acc, item) => {
    return acc + Number(item.valor_total_pedidos);
  }, 0);

  const totalPedCadastra = response.data.data.reduce((acc, item) => {
    return acc + Number(item.valor_pedido_cadastrado);
  }, 0);

  const totalPedidosClientesNovos = response.data.data.reduce((acc, item) => {
    return acc + Number(item.total_pedido_cadastrado);
  }, 0);

  const formattedData = response.data.data
    .map((item) => {
      return {
        ...item,
        nome_vendedor: item.nome_vendedor?.toLowerCase(),
        chamados_site: item.chamados_site,
        chamados_wp: item.chamados_wp,
        chamados_atendimento: item.chamados_atendimento,
        total_chamados: item.total_chamados,
        total_pedidos: item.total_pedidos,
        valor_pedido_cadastrado: formatPrice(item.valor_pedido_cadastrado),
        valor_total_pedidos: formatPrice(item.valor_total_pedidos),
        total_pedidos_clientes_novos: Number(item.total_pedido_cadastrado) || 0,
        quantidade_vendedor: response.data.length,
        quantidade_novos: parseInt(item.total_pedido_cadastrado) || 0
      };
    })
    //tras só vendedor que tem chamados difernte de zero, chamaods site, chamados wp, chamados atendimento, pode ver a variavel total_chamados
    .filter((item) => parseInt(item.total_chamados) > 0);

  const returnData = {
    data: formattedData,
    totalPedidos: totalPedidos,
    totalValorPedidos: formatPrice(totalValorPedidos),
    totalPedCadastra: formatPrice(totalPedCadastra),
    soma_total_pedidos_clientes_novos: totalPedidosClientesNovos
  };

  return returnData;
}

export function RelatorioChamados() {
  const { register, handleSubmit, setValue } = useForm();

  const {
    data: relatorioChamados,
    isLoading: isLoadingRelatorioChamados,
    mutateAsync: mutateRelatorioChamados
  } = useMutation({
    mutationFn: (data) => getRelatorioChamados(data)
  });

  const [mktValue, setMktValue] = useState();
  const [totalValues, setTotalValues] = useState({
    investimentoMkt: 0,
    valorPorChamado: 0,
    valorPorPedido: 0
  });

  function sumTotalValues(values) {
    const { investimentoMkt, valorPorChamado, valorPorPedido } = values;

    const totalInvestimentoMkt = investimentoMkt;
    const totalValorPorChamado = valorPorChamado;
    const totalValorPorPedido = valorPorPedido;

    setTotalValues({
      investimentoMkt: totalInvestimentoMkt,
      valorPorChamado: totalValorPorChamado,
      valorPorPedido: totalValorPorPedido
    });
  }

  async function handleRelatorioChamados(data) {
    try {
      await mutateRelatorioChamados(data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    const date = new Date();
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const firstDayFormatted = firstDayOfMonth.toISOString().split('T')[0];
    const lastDayFormatted = lastDayOfMonth.toISOString().split('T')[0];

    setValue('data_inicial', firstDayFormatted);
    setValue('data_final', lastDayFormatted);

    handleRelatorioChamados({
      data_inicial: firstDayFormatted,
      data_final: lastDayFormatted
    });
  }, [setValue]);

  return (
    <>
      <HeadingPages name="Relatório de Chamados" />

      <Layout>
        <Flex flexDir="column" my="5" maxW="500px" mx="auto">
          <Text fontSize="sm" fontWeight="bold">
            Filtrar por período
          </Text>
          <Flex
            alignItems="center"
            gap="4"
            as="form"
            onSubmit={handleSubmit(handleRelatorioChamados)}>
            <Input type="date" {...register('data_inicial')} />
            <Input type="date" {...register('data_final')} />
            <Button colorScheme="blue" maxW="100px" w="100%" type="submit">
              Filtrar
            </Button>
          </Flex>
        </Flex>

        <Input
          type="text"
          placeholder="Valor investido em marketing"
          ml="auto"
          my={2}
          maxW="250px"
          justifyContent="flex-end"
          display="flex"
          _placeholder={{
            color: 'gray.700'
          }}
          onChange={(e) => setMktValue(e.target.value)}
        />

        <TableContainer>
          <Table colorScheme="gray" variant="striped" size="sm" borderCollapse="collapse">
            <Thead>
              <Tr>
                <Th bgColor="#378BBF" color="white">
                  Vendedor
                </Th>
                <Th bgColor="#378BBF" color="white">
                  SITE
                </Th>
                <Th bgColor="#378BBF" color="white">
                  WhatsApp
                </Th>
                <Th bgColor="#378BBF" color="white">
                  ATENDIMENTO
                </Th>
                <Th bgColor="#378BBF" color="white" textAlign="center">
                  TOTAL <br /> CHAMADOS
                </Th>
                <Th bgColor="#378BBF" color="white" textAlign="center">
                  TOTAL <br /> Ped
                </Th>
                <Th bgColor="#378BBF" color="white" textAlign="center">
                  Total ped <br /> clientes novos
                </Th>
                <Th bgColor="#378BBF" color="white">
                  Valor TOTAL Ped.
                </Th>
                <Th bgColor="#378BBF" color="white" textAlign="center">
                  Valor total Pedidos <br /> de clientes novos
                </Th>
                <Th bgColor="#378BBF" color="white" textAlign="center">
                  Investimento <br /> em Marketing
                </Th>

                <Th bgColor="#378BBF" color="white" textAlign="center">
                  Valor por <br /> chamado
                </Th>
                <Th bgColor="#378BBF" color="white" textAlign="center">
                  Valor por <br /> pedido
                </Th>
              </Tr>
            </Thead>

            <Tbody>
              <RowsContainer items={relatorioChamados} mktValue={mktValue} />
            </Tbody>
          </Table>
        </TableContainer>
      </Layout>
    </>
  );
}
